import React from "react";
//import stilePulsanti from "../interfaccia/stilePulsanti";
import OrdiniInQuestoStato from "./OrdiniInQuestoStato";
import OrdiniInQuestoStatoSelfUpdating from "./OrdiniInQuestoStatoSelfUpdating";
import TastoRitirati from "./TastoRitirati";

function RiquadroStatoBeta({
    arrDuplicati,
    nomeRiquadro,
    nomeStato,
    coloreRiquadro,
    coloreScritta,
    statoSelezionato,
    cambiaStato,
    ordiniInArray
}) {

    /* const {
        buttonClassesWhite
    } = stilePulsanti */

    //const utente = props.utente;
    /* const nomeRiquadro = props.nomeRiquadro;
    const nomeStato = props.nomeStato;
    const coloreRiquadro = props.coloreRiquadro;
    const coloreScritta = props.coloreScritta;
    const statoSelezionato = props.statoSelezionato;
    const cambiaStato = props.cambiaStato;
    const ordiniInArray = props.ordiniInArray; */
    //const ordiniTrasmessi = props.ordiniTrasmessi.sort(function(a, b){return b-a});

    let className;
    if (statoSelezionato === nomeStato) {
        className = "tc riquadroStato w-10 bg-" + coloreRiquadro + " " + coloreScritta + " pa2 pb4"
    } else {
        className = "tc riquadroStato w-10 bg-light-gray silver pa2 pb4"
    }

    let buttonClassName;
    if (statoSelezionato === nomeStato) {
        buttonClassName = "f6 mb2 pa2 w-100 bw0 pointer bg-" + coloreRiquadro + " " + coloreScritta
    } else {
        buttonClassName = "f6 mb2 dim bg-light-gray silver pa2 w-100 bw0 pointer"
    }

    const funzioneButton = function () {
        cambiaStato(nomeStato)
    }

    


    return (
        <div className={className}>
            <button
                className={buttonClassName}
                onClick={funzioneButton}
            >
                <h2 className="h2">{nomeRiquadro}</h2>
            </button>
            <h4>Ordini in cache</h4>
            <p>
                {ordiniInArray && ordiniInArray}
            </p>
            <h4>Duplicati</h4>
            <p>
                {arrDuplicati && arrDuplicati.map((dupl) => <p>{dupl[0]}: x{dupl[1]}</p>)}
            </p>
            <div>
            {nomeRiquadro === "BRT" && <TastoRitirati stato={nomeStato} nuovoStato={"RITIRATO DA BRT"}/>}
            {nomeRiquadro === "GLS" && <TastoRitirati stato={nomeStato} nuovoStato={"RITIRATO DA GLS"}/>}
            {nomeRiquadro === "DHL" && <TastoRitirati stato={nomeStato} nuovoStato={"RITIRATO DA DHL"}/>}
            {nomeRiquadro === "UPS" && <TastoRitirati stato={nomeStato} nuovoStato={"RITIRATO DA UPS"}/>}
            {nomeRiquadro !== "BRT" && 
                nomeRiquadro !== "GLS" && 
                nomeRiquadro !== "DHL" && 
                nomeRiquadro !== "UPS" && <TastoRitirati stato={nomeStato} nuovoStato={"ARCHIVIATO"}/>}
            </div>
            <div className="ordiniTrasmessi">
                {statoSelezionato !== nomeStato && <OrdiniInQuestoStato stato={nomeStato} />}
                {statoSelezionato === nomeStato && <OrdiniInQuestoStatoSelfUpdating stato={nomeStato} />}
            </div>
        </div>
    )
}

export default RiquadroStatoBeta;